// import external dependencies
import jquery from 'jquery';

declare global {
  interface Window {
    $: typeof jquery;
    jQuery: typeof jquery;
  }
}

window.$ = window.jQuery = jquery;

import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';

import './modules/hamburger';
import './modules/sticky-header';
import './modules/language-switcher';
import './modules/sliders';
import './modules/aos';
import './modules/fancybox';
import './modules/copy';
import './modules/share';
import './modules/mapbox';
import './modules/filters';
import './modules/see-more';
import './modules/pocket-list';
